export const GET_EVENTS = "GET_EVENTS";
export const CLEAR_EVENTS = "CLEAR_EVENTS";

export const SET_SELECTED_EVID = "SET_SELECTED_EVID";
export const CLEAR_SELECTED_EVID = "CLEAR_SELECTED_EVID";

export const SET_SELECTED_EVENT_INDEX = "SET_SELECTED_EVENT_INDEX";
export const CLEAR_SELECTED_EVENT_INDEX = "CLEAR_SELECTED_EVENT_INDEX";

export const GET_TODAYS_EVENTS = "GET_TODAYS_EVENTS";